module.exports = __webpack_public_path__ + "assets/src/style/img/footer-provincie.png?f5c775c1414da1c39ac07056222dd44f";